import { useRenderBillingRoutes } from "./useRenderBillingRoutes";
import { useRenderDebugRoutes } from "./useRenderDebugRoutes";
import { useRenderOAuthRoutes } from "./useRenderOAuthRoutes";

export const useRenderCommonRoutes = () => {
    const oauthRoutes = useRenderOAuthRoutes();
    const billingRoutes = useRenderBillingRoutes();
    const debugRoutes = useRenderDebugRoutes();

    return (
        <>
            {debugRoutes}
            {oauthRoutes}
            {billingRoutes}
        </>
    );
};
